/* TestEmailRenderer.js */

"use strict";

const uiCore = require("@gluenetworks/steve_ui_core");

const TextControl = uiCore.Control.Textfield.InputText;
const ButtonControl = uiCore.Control.Action.Button;

const MODAL_TITLE = "Test SMTP Configuration";
const RECEIVER_EMAIL_LABEL = "Enter email to receive test mail";

const EmailRegex = new RegExp(/^(.*\s<(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))>)|((([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,})))$/);

/**
 * @class TestEmailRenderer
 *
 */
class TestEmailRenderer {
    constructor(model) {
        this._model = model;

        this._rootElem = this._createRootElement();

        this._validateButton = new ButtonControl({
            label: "Send Test Email",
            darkTheme: true,
            disabled: true,
            active: true
        });
        this._cancelButton = new ButtonControl({ label: "Cancel", darkTheme: true });
        this._receiverEmail = new TextControl({darkTheme: true});
        this._receiverEmail.setValue(this._model._userEmail);
        
        this._actionsContainer = document.createElement("div");
        this._actionsContainer.classList.add("test-email-actions", "action-container");

        this._actionsContainer.appendChild(this._cancelButton.renderer.getRootElement());
        this._actionsContainer.appendChild(this._validateButton.renderer.getRootElement());
        this._registerListeners();
        this.render();
    }

    get rootElement() {
        return this.getRootElement();
    }

    get model() {
        return this.getModel();
    }

    /*******************************************/
    /* START PUBLIC COMPONENT RENDERER METHODS */
    /*******************************************/
    render() {
        if (this._renderProm === null) {
            return Promise.resolve();
        }
        this._renderProm = this._renderProm || this._render();
        return this._renderProm;
    }

    shutdown() {
        if (this._shutdownProm === null) {
            return Promise.resolve();
        }
        this._shutdownProm = this._shutdownProm || this._shutdown();
        return this._shutdownProm;
    }

    getRootElement() {
        return this._rootElem;
    }

    getModel() {
        return this._model;
    }

    /********************************************/
    /* END PUBLIC COMPONENT RENDERER METHODS    */
    /* START PRIVATE COMPONENT RENDERER METHODS */
    /********************************************/

    _registerListeners() {
        this._cancelButton.on("UserClick", () => this._model.closePopUp());
        this._validateButton.on("UserClick", this._onValidate = this._onValidate.bind(this));
        this._receiverEmail.on("UserValue",this._onReceiverEmailChange = this._onReceiverEmailChange.bind(this));
    }

    _unregisterListeners() {
        this._cancelButton.removeAllListeners("UserClick");
        this._validateButton.removeListener("UserClick", this._onValidate);
        this._receiverEmail.removeListener("UserValue",this._onReceiverEmailChange);
    }

    _render() {
        this._rootElem.innerHTML = "";
        const root = document.createDocumentFragment();
        const title = document.createElement("h2");
        const label = document.createElement("label");
        label.innerText = RECEIVER_EMAIL_LABEL;
        title.innerText = MODAL_TITLE;

        root.appendChild(title);
        root.appendChild(label);
        root.appendChild(this._receiverEmail.renderer.rootElement);
        root.appendChild(this._actionsContainer);
        setTimeout(this.focusInput.bind(this), 0);
        return new Promise((resolve /*,reject*/) => {
            this._rootElem.appendChild(root);
            this._checkButtons();
            resolve();
        });
    }

    _shutdown() {
        this._unregisterListeners();
        this._rootElem.remove();
        this._rootElem = null;

        return Promise.all([
            this._validateButton.shutdown(),
            this._cancelButton.shutdown()
        ])
            .then(() => {
                this._model = null;
                this._shutdownProm = null;
                this._renderProm = null;
            })
            .catch((error) => {
                console.log(`${this.constructor.name}: error in shutdown`);
                console.error(error);
            });
    }

    /********************************************/
    /* END PRIVATE COMPONENT RENDERER METHODS   */
    /* START PRIVATE RENDERER METHODS           */
    /********************************************/

    _createRootElement() {
        const rootElement = document.createElement("div");
        rootElement.classList.add("test-email-veil", "modal_feedback_container");
        rootElement.component = this._model;
        return rootElement;
    }

    /********************************************/
    /* END PRIVATE RENDERER METHODS             */
    /* START HANDLER METHODS                    */
    /********************************************/

    _onReceiverEmailChange() {
        this._checkButtons();
    }

    _onValidate() {
        const email = this._receiverEmail.getValue();
        this._model.validate(email);
    }

    /********************************************/
    /* END HANDLER METHODS                      */
    /* START PRIVATE API METHODS                */
    /********************************************/

    _checkButtons() {
        const receiverEmail = this._receiverEmail.getValue();
        const valid = receiverEmail && EmailRegex.test(receiverEmail);
        this._validateButton.setDisabled(!valid);
        this._cancelButton.setDisabled(false);
    }

    _setError(msg) {
        this._errorContainer.innerText = msg;
    }
    /*******************************************/
    /*  END PRIVATE API METHODS                */
    /* START PUBLIC API METHODS                */
    /********************************************/

    focusInput() {
        this._receiverEmail.focus();
    }

    /*******************************************/
    /*  END PUBLIC API METHODS                */
    /*******************************************/
}

module.exports = TestEmailRenderer;
